import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const StateFilledCheckboxCheckboxIcon: React.FC<IconProps> = props => (
  <Icon {...props}>
    <path
      d="M10.727 16.2L17.777 9.15L16.377 7.75L10.727 13.4L7.87695 10.55L6.47695 11.95L10.727 16.2ZM5.12695 21C4.57695 21 4.10612 20.8042 3.71445 20.4125C3.32279 20.0208 3.12695 19.55 3.12695 19V5C3.12695 4.45 3.32279 3.97917 3.71445 3.5875C4.10612 3.19583 4.57695 3 5.12695 3H19.127C19.677 3 20.1478 3.19583 20.5395 3.5875C20.9311 3.97917 21.127 4.45 21.127 5V19C21.127 19.55 20.9311 20.0208 20.5395 20.4125C20.1478 20.8042 19.677 21 19.127 21H5.12695Z"
      fill="currentColor"
    />
  </Icon>
)
